/**
 * "Fits your iPhone 18 Pro" badge on product cards.
 *
 * Accessories made for a model that fits another (iPhone 17 Pro -> 18 Pro, see
 * AIOO_COMPAT_ALIASES in aioo-model-normalize.js) carry both models in custom.compatible_model, so
 * they show up when a shopper filters by the alias model. The title still names the native model,
 * so say plainly that the product fits the shopper's phone. Cards expose their models as data-cm
 * (product-card-grid.liquid) and an empty .fits-device-badge placeholder.
 */
(function (window, document) {
  'use strict';

  var FILTER_PARAM = 'filter.v.m.custom.compatible_model';

  function norm(s) {
    return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /* Models the shopper is looking at: filter values, ?aioo_model=, or a per-model collection
     (/collections/iphone-18-pro-max-cases). Only the URL counts, not the remembered device, so
     the badge appears exactly where the shopper asked for that model. */
  function activeModels() {
    var out = [];
    try {
      var u = new URL(window.location.href);
      u.searchParams.forEach(function (val, key) {
        if (key === FILTER_PARAM || key === 'aioo_model') out.push(norm(val));
      });
      var m = u.pathname.match(/\/collections\/(iphone-[a-z0-9-]+?)-cases\/?$/);
      if (m) out.push(norm(m[1].replace(/-/g, ' ')));
    } catch (_e) { /* ignore */ }
    return out.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }

  function labelFor(slug) {
    return typeof window.AIOO_formatModelLabel === 'function' ? window.AIOO_formatModelLabel(slug) : slug;
  }

  function isAliasOf(alias, natives) {
    var kinds = window.AIOO_COMPAT_ALIASES || {};
    return Object.keys(kinds).some(function (kind) {
      var map = kinds[kind];
      return Object.keys(map).some(function (native) {
        return natives.indexOf(native) !== -1 && map[native].indexOf(alias) !== -1;
      });
    });
  }

  function apply(root) {
    var active = activeModels();
    if (!active.length || !window.AIOO_COMPAT_ALIASES) return;
    (root || document).querySelectorAll('.grid-view-item[data-cm]').forEach(function (card) {
      if (card.getAttribute('data-fit-badge-done') === '1') return;
      var models = String(card.getAttribute('data-cm') || '').split(',').map(norm);
      var badge = card.querySelector('.fits-device-badge');
      if (!badge) return;
      var hit = active.filter(function (a) {
        return models.indexOf(a) !== -1 && isAliasOf(a, models);
      })[0];
      if (!hit) return;
      var tpl = window.AIOO_FIT_BADGE || '{model}';
      badge.textContent = tpl.replace('{model}', labelFor(hit));
      badge.style.display = '';
      badge.classList.add('is-visible');
      card.setAttribute('data-fit-badge-done', '1');
    });
  }

  function init() { apply(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Grids re-render after AJAX filtering and infinite scroll. */
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; apply(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})(window, document);
